module.exports = __webpack_public_path__ + "media/images/emblems/Berlingen_Wappen_2-d3b1034ec8bb6b35b85535c112354ee8.svg";